export const partnerProgramEventSagaActionTypes = {
  callEventListConfigurationSaga: "callEventListConfigurationSaga",
  callAddEventListConfigurationSaga: "callAddEventListConfigurationSaga",
  callPointListConfigurationSaga: "callPointListConfigurationSaga",
  callPointDraftSummaryListConfigurationSaga:
    "callPointDraftSummaryListConfigurationSaga",
  callPointSummaryListConfigurationSaga:
    "callPointSummaryListConfigurationSaga",
  callUpdateEventListConfigurationSaga: "callUpdateEventListConfigurationSaga",
  callAddSubmitForEvalutionConfigurationSaga:
    "callAddSubmitForEvalutionConfigurationSaga",
  callDraftSubmitForEvalutionConfigurationSaga:
    "callDraftSubmitForEvalutionConfigurationSaga",
  getFileUrlSaga: "getFileUrlSaga",
  callUpdatePartnerPointsSaga: "callUpdatePartnerPointsSaga",
  callDeletePartnerPointsSaga: "callDeletePartnerPointsSaga",
};

export const getOverviewEventListing: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerProgramEventSagaActionTypes.callEventListConfigurationSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getPartnerPoints: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerProgramEventSagaActionTypes.callPointListConfigurationSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getPartnerPointsSummary: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerProgramEventSagaActionTypes.callPointSummaryListConfigurationSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getPartnerPointsDraftSummary: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerProgramEventSagaActionTypes.callPointDraftSummaryListConfigurationSaga,
    payload: {
      ID: ID,
    },
  };
};

export const AddEvent: (eventDeatils: any) => {
  type: string;
  payload: {
    eventDeatils: any;
  };
} = (eventDeatils) => {
  return {
    type: partnerProgramEventSagaActionTypes.callAddEventListConfigurationSaga,
    payload: {
      eventDeatils: eventDeatils,
    },
  };
};

export const UpdateEvent: (eventDeatils: any) => {
  type: string;
  payload: {
    eventDeatils: any;
  };
} = (eventDeatils) => {
  return {
    type: partnerProgramEventSagaActionTypes.callUpdateEventListConfigurationSaga,
    payload: {
      eventDeatils: eventDeatils,
    },
  };
};

export const AddCalculator: (eventDeatils: any) => {
  type: string;
  payload: {
    eventDeatils: any;
  };
} = (eventDeatils) => {
  return {
    type: partnerProgramEventSagaActionTypes.callAddSubmitForEvalutionConfigurationSaga,
    payload: {
      eventDeatils: eventDeatils,
    },
  };
};

export const SaveDraft: (eventDeatils: any) => {
  type: string;
  payload: {
    eventDeatils: any;
  };
} = (eventDeatils) => {
  return {
    type: partnerProgramEventSagaActionTypes.callDraftSubmitForEvalutionConfigurationSaga,
    payload: {
      eventDeatils: eventDeatils,
    },
  };
};

export const getFileUrl: (
  fileName: any,
  type: any
) => {
  type: string;
  payload: {
    fileName: any;
    type: any;
  };
} = (fileName: any, type: any) => {
  return {
    type: partnerProgramEventSagaActionTypes.getFileUrlSaga,
    payload: {
      fileName: fileName,
      type: type,
    },
  };
};

export const updatePartnerPoints: (payload: {
  id: number;
  partnerId: number;
  body: FormData | Record<string, unknown>;
}) => {
  type: string;
  payload: {
    id: number;
    partnerId: number;
    body: FormData | Record<string, unknown>;
  };
} = (payload) => ({
  type: partnerProgramEventSagaActionTypes.callUpdatePartnerPointsSaga,
  payload,
});

export const deletePartnerPoints: (payload: {
  assessmentId: number;
  partnerId: number;
}) => {
  type: string;
  payload: {
    assessmentId: number;
    partnerId: number;
  };
} = (payload) => ({
  type: partnerProgramEventSagaActionTypes.callDeletePartnerPointsSaga,
  payload,
});
